// extracted by mini-css-extract-plugin
export var centerText = "_bh-8";
export var container = "_bh-0";
export var doughnutContainer = "_bh-7";
export var legend = "_bh-a";
export var legendItemColorDisplay = "_bh-b";
export var legendItemLabel = "_bh-c";
export var lg = "_bh-5";
export var maxWidth = "_bh-9";
export var md = "_bh-4";
export var responsive = "_bh-6";
export var sm = "_bh-3";
export var xs = "_bh-2";
export var xxs = "_bh-1";